import Button from "./Button";
import { scroll } from "./Scroll";

import "./Description.scss";

const FOUNDATION_YEAR = 2008;

function getYearsWord(years) {
  const lastTwoDigits = years % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return "лет";
  }

  switch (years % 10) {
    case 1:
      return "год";
    case 2:
    case 3:
    case 4:
      return "года";
    default:
      return "лет";
  }
}

export default function Description() {
  const yearsInBusiness = new Date().getFullYear() - FOUNDATION_YEAR;

  function onClick() {
    scroll("about-us");
  }

  return (
    <div className="description-wrapper" id="description">
      <div className="description-title">
        СТУДИЯ ДИЗАЙНА И АРХИТЕКТУРНОГО ПРОЕКТИРОВАНИЯ
      </div>
      <div className="description-name">SAS STYLE STUDIO</div>
        <div className="description-text">
          <p>
            Мы рады приветствовать вас на нашем сайте. Вот уже более {" "}
            {yearsInBusiness} {getYearsWord(yearsInBusiness)} мы стараемся
            сделать ваш дом уютным стильным и функциональным.
          </p>
        <p>
          Наша работа начинается со звонка к нам, дизайнер выезжает на замер и
          мы начинаем творить для вас пространство.
        </p>
      </div>
      <Button colorScheme="white" onClick={onClick}>
        ЧИТАТЬ ПОДРОБНЕЕ О БЮРО
      </Button>
      <div className="description-world-wrapper">
        <div className="description-world-header">
          Интерьер любой сложности от классики до авангарда
        </div>
        <div className="description-world-text copy-text">
          Миссия нашего бюро — создавать уникальные пространства, сотрудничая
          только с лучшими специалистами, клиентами и мастерами. Мы продолжаем
          внедрять передовые технологии в нашу практику и стремимся к искусству
          и моде для вдохновения. Каждый проект создается с учетом потребностей
          и характера клиента.
        </div>
      </div>
    </div>
  );
}
